import { render, staticRenderFns } from "./lkuUserClients.vue?vue&type=template&id=5be11feb"
import script from "./lkuUserClients.vue?vue&type=script&lang=js"
export * from "./lkuUserClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports